import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import projectCardStyle from './ProjectCard.module.scss';
import commonStyle from '../../styles/commonStyles.module.scss';
import { IProject } from '../../interfaces/interfaces';
import IModal from '../elements/iModal/IModal';
import ImagesCarousle from '../elements/imagesCarousel/ImagesCarousel';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

interface IProps {
    project: IProject;
}

const ProjectCard = (props: IProps) => {
    const [showImageModal, setShowImageModal] = useState<boolean>(false);
    const { project } = props;
    const { t } = useTranslation();

    const mainImage = project?.images?.find((image) => image.default) || project?.images?.[0];
    const hasGallery = project.images.length > 1;

    const closeModalHandler = () => setShowImageModal(false);

    return (
        <article className={projectCardStyle.card}>
            <button
                type='button'
                className={projectCardStyle.media}
                onClick={() => setShowImageModal(true)}
                aria-label={`${t('projectCard.viewImages')} — ${project.name}`}
            >
                <img src={mainImage?.image} alt={`${project.name} preview`} className={projectCardStyle.image} loading='lazy' />
                <span className={projectCardStyle.mediaOverlay}>
                    <span className={projectCardStyle.zoom}>
                        <ZoomInIcon />
                        {hasGallery ? `${project.images.length} ${t('projectCard.images')}` : t('projectCard.viewImages')}
                    </span>
                </span>
            </button>

            <div className={projectCardStyle.body}>
                <div className={projectCardStyle.meta}>
                    <span className={projectCardStyle.year}>{project.year}</span>
                    <span className={projectCardStyle.dot} />
                    <span className={projectCardStyle.role}>{project.role}</span>
                    {project.badge && <span className={projectCardStyle.badge}>{project.badge}</span>}
                </div>

                <h3 className={projectCardStyle.title}>{project.name}</h3>
                <p className={projectCardStyle.description}>{project.description}</p>

                <div className={`${commonStyle.tagRow} ${projectCardStyle.tech}`}>
                    {project?.tech?.map((tech, i) => (
                        <span key={i} className={commonStyle.tag}>
                            {tech}
                        </span>
                    ))}
                </div>
            </div>

            <IModal isOpen={showImageModal} closeModalHandler={closeModalHandler} label={project.name}>
                <ImagesCarousle images={project.images} name={project.name} />
            </IModal>
        </article>
    );
};

export default ProjectCard;
